<template>
    <!-- 小步骤 -->
    <div>
        <!-- 小步骤的标签名 -->
        <slot name="label">
            <info-icon
                :class="{'f-topic-official-more-label': true,
                    'has-padding': hasPadding}"
                :info="info">
            </info-icon>
        </slot>

        <!-- 小步骤附加 -->
        <slot name="annex"></slot>

        <!-- 小步骤的选项 -->
        <slot name="options"></slot>

        <!-- 小步骤的编辑器 -->
        <slot name="editor"></slot>

        <!-- 小步骤信息展示 -->
        <slot name="text"></slot>
    </div>
</template>

<style lang="less">
    @import '../../../../assets/less/views/topic-content/official-process/official-process-board.less';
</style>

<script>
    import InfoIcon from './InfoIcon.vue';

    export default {
        components: {
            'info-icon': InfoIcon
        },
        props: {
            info: Object,
            hasPadding: Boolean
        }
    };
</script>
